export default "__VITE_ASSET__YxBiJTfc__"